import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
export default React.forwardRef(function Button({ name, type = 'button', size = 'medium', color = 'accent', children, style, bordered = false, onClick, disabled = false, className = '', noTextWrap = true }, ref) {
    return _jsx(Container, { name: name, type: type, size: size, color: color, style: style, bordered: bordered, onClick: onClick, disabled: disabled, className: `${className} ui-button`, noTextWrap: noTextWrap !== null && noTextWrap !== void 0 ? noTextWrap : true, children: children });
});
export const Container = styled.button `
  position: relative;
  font-family: inherit;
  font-size: 0.75rem;
  color: var(--text-primary);
  outline: none;
  border: none;
  cursor: pointer;
  transition: background-color ease .3s;

  ${props => props.noTextWrap && css `
    white-space: nowrap;
  `}

  opacity: 0.9;

  &:hover > * {
    opacity: 0.87;
  }

  & > a {
    color: inherit;
    text-decoration: none;
  }

  ${props => props.size === 'big' && css `
    padding-left: var(--ui-button-padding-h-big);
    padding-right: var(--ui-button-padding-h-big);
    padding-top: var(--ui-button-padding-big);
    padding-bottom: var(--ui-button-padding-big);
    border-radius: var(--ui-border-radius-big);
    font-size: var(--ui-font-size-big);
    line-height: var(--ui-line-height-big);
    font-weight: 500;
  `}

  ${props => props.size === 'medium' && css `
    padding-left: var(--ui-button-padding-h-medium);
    padding-right: var(--ui-button-padding-h-medium);
    padding-top: var(--ui-button-padding-medium);
    padding-bottom: var(--ui-button-padding-medium);
    border-radius: var(--ui-border-radius-medium);
    font-size: var(--ui-font-size-medium);
    line-height: var(--ui-line-height-medium);
  `}

  ${props => props.size === 'small' && css `
    padding-left: var(--ui-button-padding-h-small);
    padding-right: var(--ui-button-padding-h-small);
    padding-top: var(--ui-button-padding-small);
    padding-bottom: var(--ui-button-padding-small);
    border-radius: var(--ui-border-radius-small);
    font-size: var(--ui-font-size-small);
    line-height: var(--ui-line-height-small);
  `}

  ${props => props.color === 'red' && css `
    background: var(--ui-color-red);
  `}

  ${props => props.color === 'accent' && css `
    color: var(--ui-color-white);
    background: var(--ui-accent-color);
  `}

  ${props => props.color === 'white' && css `
    background: transparent;
    color: var(--ui-accent-color);
  `}

  ${props => props.color === 'orange' && css `
    background: var(--ui-color-orange);
  `}

  ${props => props.color === 'pink' && css `
    background: var(--ui-color-pink);
  `}

  ${props => props.color === 'transparent' && css `
    background: none; /* Вынести */
    color: var(--text-inverse);
  `}

  ${props => props.color === 'transparentWithBorder' && css `
    background: transparent; /* Вынести */
    color: var(--text-inverse);
    border: 1px solid var(--ui-input-border-color);
  `}

  ${props => props.color === 'blur' && css `
    background: none; /* Вынести */
    backdrop-filter: brightness(0.9) blur(3px);
  `}

  ${props => (props.color.startsWith('#') || props.color.startsWith('rgb') || props.color.startsWith('var')) && css `
    background: ${props.color};
    color: var(--ui-color-white);
  `}

  ${props => props.bordered && css `
    box-shadow: 0 0 0 1px var(--ui-input-border-color);
  `}

  ${props => props.disabled && css `
    color: var(--text-third);
    ${!props.bordered && css `
      background: var(--ui-input-border-color);
    `}
    pointer-events: none;
  `}
`;
